export const GET_DATA = "GET_DATA";
export const GET_MENU = "GET_MENU";
export const SEARCH_MENU = "SEARCH_MENU";
export const ADD_TO_CART = "ADD_TO_CART";
export const MINUS_TO_CART = "MINUS_TO_CART";
export const FILTER_ITEMS = "FILTER_ITEMS";
export const GET_SPL_MENU = "GET_SPL_MENU";
export const SPL_CAT = "SPL_CAT";
export const CHANGEPOPSTATUS = "CHANGEPOPSTATUS";
export const SETTOKEN = "SETTOKEN";
export const SETSERVERCART = "SETSERVERCART";
export const SET_MULTI_ORDER_POPUP_SHOWN = "SETMULTIORDERPOPUPSHOWN";
export const SET_VOUCHER_CODE = "SET_VOUCHER_CODE";
export const SETCARTERROR = "SETCARTERROR";
export const SETPAYMENT = "SETPAYMENT";
export const ORDERSUCESS = "ORDERSUCESS";
export const GETORDERS = "GETORDERS";
export const GETSELECTEDORDER = "GETSELECTEDORDER";
export const SETERROR = "SETERROR";
export const ORDERREDIRECT = "ORDERREDIRECT";
export const FINALCARTRESPONSE = "FINALCARTRESPONSE";
export const FINALSETTLE = "FINALSETTLE";
export const REDIRECTORDER = "REDIRECTORDER";
export const SETORDERCOUNT = "SETORDERCOUNT";
export const SETORDERINSTRUCTIONS = "SETORDERINSTRUCTIONS";
export const SETVOUCHERSUCCESS = "SETVOUCHERSUCCESS";
export const LOGOUT = "LOGOUT";
export const GETORDERHISTORY = "GETORDERHISTORY";
export const SETTABLE = "SETTABLE";
export const TABLE_ERROR = "TABLE_ERROR";
export const REMOVETABLE = "REMOVETABLE";
export const SETFINALCARTERROR = "SETFINALCARTERROR";
export const SETISLOADING = "SETISLOADING";
export const SETDEVICETOKEN = "SETDEVICETOKEN";
export const GET_MERCHANT = "GET_MERCHANT";
export const WAITER_CALLED = "WAITER_CALLED";
export const SET_CONTINUE_ORDERING = "SET_CONTINUE_ORDERING";